import { useTranslation } from 'react-i18next';
import { Linkedin } from 'lucide-react';
import { BRAND } from '@/config/brand';

export default function Footer() {
    const { t } = useTranslation(['admin']);
    return (
        <footer className="bg-[#0a0a0a] py-12 border-t border-white/5">
            <div className="max-w-6xl mx-auto px-6">
                <div className="flex flex-col md:flex-row justify-between items-center gap-6">
                    {/* Logo */}
                    <div className="flex items-center gap-2">
                        <img 
                                                        src="https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/692d6394a23762baf1ff05b8/4a1265ef2_r.png" 
                                                        alt={BRAND.name} 
                                                        className="h-6 sm:h-8 w-auto"
                                                    />
                        <span className="text-base sm:text-lg font-semibold text-white">{BRAND.name}</span>
                    </div>

                    {/* Links */}
                    <div className="flex items-center gap-6">
                        <a
                            href="https://linkedin.com/in/pj-pouhyet"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-white/30 hover:text-white/60 transition-colors"
                        >
                            <Linkedin className="w-5 h-5" />
                        </a>

                    </div>
                </div>

                <div className="mt-8 pt-8 border-t border-white/5 flex flex-col gap-4 text-xs sm:text-sm text-white/30">
                    <div className="flex flex-col md:flex-row justify-between items-center gap-4">
                        <p>{t('admin:landing.footer.copyright', { year: new Date().getFullYear() })}</p>
                        {/* i18n-exempt: registered office, a place name */}
                        <p>Saint-Maur-des-Fossés, France 🇫🇷</p>
                    </div>
                    <div className="text-center text-white/20 text-xs border-t border-white/5 pt-4">
                        {/* i18n-exempt-start: legal notice of the French company, as registered */}
                        <p>PJP Conseil</p>
                        <p>SIREN 887 493 948 - SIRET 88749394800020 - TVA FR54887493948</p>
                        <p>29 Avenue du Mesnil, 94210 Saint-Maur-des-Fossés</p>
                        <p>Conseil pour les affaires et autres conseils de gestion (NAF 70.22Z)</p>
                        {/* i18n-exempt-end */}
                    </div>
                </div>
            </div>
        </footer>
    );
}